import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initializePerformanceHead } from './components/PerformanceHead';
initializePerformanceHead();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-221" data-mp="2690wiv8uh72s" />);
}